var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconContainer d-flex justify-content-center align-items-center"},[_c('b-img',{staticClass:"w-100",attrs:{"src":_vm.icon,"fluid":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }